import { createContext } from 'react';

// Lives in its own module so the table sub-components can consume it without importing CustomTable.jsx
// (which imports them), avoiding an import cycle.
export const TableContext = createContext(null);
